import { translate, useLocale } from "../../localization";
import './Header.scss';
import Logo  from '../../images/logo.png';

import { usePageMetadata } from '../../context/PageMetadataContext';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';
import { AppButton } from "../ui";
import LanguagePicker from "../LanguagePicker";




const Header = ({ children, dashboard, mobileMenuOpen, onMenuToggle }) => {
  useLocale();
  const { title, showTitleInHeader, headerAction } = usePageMetadata();

  const { organizationName, isAuthenticated, subscriptionStatus } = useAuth();
  const isSubscribed =
    subscriptionStatus === "subscribed" || subscriptionStatus === "perpetual";
 

  return (
    <div className={`header ${dashboard ? "header--dashboard" : ""}`}>
      <div className="header-left">
        {dashboard && isAuthenticated && (
          <button
            className="header-hamburger"
            onClick={onMenuToggle}
            aria-label={mobileMenuOpen ? translate("Close menu") : translate("Open menu")}
          >
            {mobileMenuOpen ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            )}
          </button>
        )}
        <Link to="/">
          <img src={Logo} alt={translate("10k Science")} />
        </Link>
      </div>

      {showTitleInHeader && (
        <div className="header-center">
          <h1>{title}</h1>
        </div>
      )}
      <div className="header-right">
        <LanguagePicker />
        {headerAction}
        {children}
        {dashboard && isAuthenticated && !isSubscribed && (
          <AppButton
            className="header-billing-button"
            component={Link}
            kind="primary"
            to="/upgrade"
          >{translate("Upgrade")}</AppButton>
        )}
        {dashboard && organizationName && <h2>{organizationName}</h2>}
      </div>
    </div>
  );
}

export default Header;
